export default __webpack_public_path__ + "media/JSM_mobile.03ccca68c017f2ea7cbccfa52448c01b.svg";